import React, { useState } from "react";
import { Col, Container, Row, Form, Button } from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import solisPowerApi from "../../api/solisPowerApi";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import { ROUTES } from "../../constants/webRouting";


const SpecificationEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [spec, setSpec] = useState(location.state ? location.state : { status: "Active" });

  const handleChange = (e) => setSpec({ ...spec, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!spec.name || spec.name.trim() === "") {
      setValidated(true);
      return;
    }
    try {
      if (spec.id) {
        await solisPowerApi.updateSpecification(spec);
        PubSub.publish("RECORD_SAVED_TOAST", { title: "Success", message: "Updated successfully" });
      } else {
        await solisPowerApi.createSpecification(spec);
        PubSub.publish("RECORD_SAVED_TOAST", { title: "Success", message: "Created successfully" });
      }
      navigate(ROUTES.SPECIFICATION.LIST);
    } catch (err) {
      PubSub.publish("RECORD_SAVED_TOAST", { title: "Error", message: "Something went wrong" });
    }
  };

  return (
    <Main>
      <Container className="view-form">
        <Row>
          <Col lg={8} className="mx-auto pb-1 pt-2">
            <Link className="nav-link" to={ROUTES.SPECIFICATION.LIST}>
              Home <i className="fa-solid fa-chevron-right"></i> <div style={{ color: "#23468c", display: "inline" }}>Specifications</div>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg={8} className="mx-auto">
            <Form className="mt-3" onSubmit={handleSubmit} noValidate validated={validated}>
              <Row className="view-form-header">
                <Col lg={8}>{spec.id ? <h5>Edit Specification</h5> : <h5>Create Specification</h5>}</Col>
                <Col lg={4} className="d-flex justify-content-end gap-3">
                  <Button size="sm" className="btn-save" onClick={handleSubmit}>Save</Button>
                  <Button size="sm" className="btn-cancel" onClick={() => navigate(ROUTES.SPECIFICATION.LIST)}>Cancel</Button>
                </Col>
              </Row>
              <Row className="ibs-edit-form pb-3">
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Name</Form.Label>
                    <Form.Control required type="text" name="name" value={spec.name || ""} onChange={handleChange} />
                    <Form.Control.Feedback type="invalid">Please provide name.</Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">Status</Form.Label>
                    <Form.Select name="status" value={spec.status || "Active"} onChange={handleChange} required>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Container>
    </Main>
  );
};

export default SpecificationEdit;
